import React, { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { AuthContext } from "./AuthContext";

const ProtectedRoute = () => {
    const { isAuthenticated } = useContext(AuthContext);

    if (!isAuthenticated) {
        // Redirige al login si no está autenticado
        return <Navigate to="/login" />;
    }

    // Renderiza la ruta protegida si está autenticado
    return <Outlet />;
};

export default ProtectedRoute;